/* eslint-disable camelcase */
import {useFormik} from 'formik';
import {func} from 'prop-types';
import React, {useEffect, useState} from 'react';
import {NotificationManager} from 'react-notifications';
import {useHistory} from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import {getOffersForLeague} from "../../../services/enrollments";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {Button, Col, Container, Row} from "react-bootstrap";
import {useAuth} from '../../../contexts/authContext';
import {updatePartner} from '../../../services/users';
import useDebounce from '../../../utils/useDebounce';
import {validationSchema} from './helpers';
import {isFilled} from "../../../utils";
import {useTranslation} from "react-i18next";

// React Components
import ErrorMessage from '../../../components/ErrorMessage';
import Header from '../../../components/Header';
import Input from '../../../components/Input';
import InputRadio from '../../../components/InputRadio';
import InputSelect from '../../../components/InputSelect';
import CheckBox from "../../../components/CheckBox";

// CSS Files
import '../MainPage/styles.css';
import {hasDuplicateEnrollment, searchUser} from "../../../services/leagues";

const MySwal = withReactContent(Swal);

const override = `
    position: absolute;
    top: 30px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255,0.7);
`;

let timeout = 0;

const PartnerForm = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [state, setState] = useState({
    offers: [],
    sizes: []
  });
  const auth = useAuth();
  const history = useHistory();
  const { t } = useTranslation();

  const initialValues = {
    original_details: {},
    loggedUserEmail: auth.user.email,
    email: '',
    name: '',
    gender: '',
    birthyear: '',
    doesBirthyearExist: false,
    phone: '',
    doesPhoneExist: false,
    facebook: '',
    fppLicence: '',
    hasFppLicence: false,
    hasSocialMedia: false,
    offerId: 'DEFAULT',
    offerSizeId: 'DEFAULT',
    authToShareSubInfo: false,
    fppLicenceIsValid: false,
    welcomePackNeeded: auth.user.active_enrollment.welcomepack_needed
  };

  const handleOnSubmit = async values => {
    const {
      league_category_id,
      league_division_id,
      league_edition_id
    } = auth.user.active_enrollment;

    const params = {
      welcomepack_location: auth.user.active_enrollment.welcomepack_location,
      birthyear: String(values.birthyear),
      facebook: values.facebook,
      fpp_licence: String(values.fppLicence),
      gender: values.gender,
      name: values.name,
      phone_number: String(values.phone),
      league_id: auth.user.active_enrollment.league_id,
      league_category_id,
      league_edition_id,
      league_division_id,
      offer_id: values.offerId,
      offer_size_id: values.offerSizeId,
      partner_name: values.name,
      partner_phone_number: values.phone,
      partner_fpp_licence: values.fppLicence,
      partner_gender: values.gender,
      partner_birthyear: values.birthyear,
      partner_has_social_media: values.hasSocialMedia,
      partner_facebook: values.facebook,
      partner_email: values.email,
      partner_to_log: "substitution"
    };

    try {
      const hasDuplicateEnrollments = await hasDuplicateEnrollment(debouncedEmail, auth.user.active_enrollment.league_id, auth.user.active_enrollment.league_category_id)

      if (hasDuplicateEnrollments === true) {
        showDuplicateEnrollmentsPopUp();
      }else{
        let originalEnrollmentId = auth.user.active_enrollment.enrollment_id
        await updatePartner(params, originalEnrollmentId);

        MySwal.fire({
          showCancelButton: false,
          title: t("substitution_request_page.request_submitted"),
          text: t("substitution_request_page.wait_for_approval"),
          confirmButtonText: "Ok"
        }).then(() => {
          history.push("/my-games");
        });
      }

    } catch (e) {
      NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleOnSubmit
  });

  const debouncedEmail = useDebounce(formik.values.email);

  const updateFormValues = res => {
    let foundOffer = state.offers.find(offer => offer.id === res.offer_id);

    let values = {
      original_details: res,
      email: res.email.toLowerCase(),
      name: res.name,
      gender: res.gender ? res.gender : "DEFAULT",
      birthyear: res.birthyear ? "****" : "",
      doesBirthyearExist: isFilled(res.birthyear),
      phone: res.phone_number ? res.phone_number : "",
      doesPhoneExist: isFilled(res.phone_number),
      offerId: foundOffer ? foundOffer.id : "DEFAULT",
      offerSizeId: state.sizes.find(offerSize => offerSize.id === res.offer_size_id),
      welcomePackNeeded: auth.user.active_enrollment.welcomepack_needed,
      authToShareSubInfo: false,
      fppLicenceIsValid: false,
      hasSocialMedia: res.social_media
    };

    if (res.fpp_licence) {
      values = {
        ...values,
        fppLicence: res.fpp_licence,
        hasFppLicence: true
      };
    } else {
      values = {
        ...values,
        fppLicence: ''
      }
    }

    if (res.social_media) {
      values = {
        ...values,
        facebook: res.site_url,
        hasSocialMedia: true
      };
    }else {
      values = {
        ...values,
        facebook: ''
      }
    }

    getSizesForOffer(res.offer_id);
    formik.setValues(values);
  };

  const getSizesForOffer = (offer_id) => {
    var sizes = []
    state.offers.map((offer) => {
      if(offer.id == offer_id){
        if(offer.sizes[0].size_name !== "GENERIC"){
          sizes = offer.sizes
          setState({
            ...state,
            sizes
          })
        }
      }
    })
  }

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        let offers = await getOffersForLeague(auth.user.active_enrollment.league_edition_id)
        setState({
          ...state,
          offers
        })
      }catch(e) {
        NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
    };

    fetchOffers();

    const fetchData = async () => {
      if(!formik.errors.email){
        setIsSearching(true);
        try {
          const res = await searchUser(debouncedEmail);
          const hasDuplicateEnrollments = await hasDuplicateEnrollment(debouncedEmail, auth.user.active_enrollment.league_id, auth.user.active_enrollment.league_category_id)

          if (res === 'NOT_FOUND') {
            MySwal.fire({
              allowOutsideClick: false,
              showCancelButton: true,
              title: t("registration_page.new_player"),
              text: t("registration_page.player_not_found"),
              confirmButtonText: t("registration_page.continue"),
              cancelButtonText: t("registration_page.fix_email")
            }).then((res) => {
              if (res.dismiss === Swal.DismissReason.cancel){
                formik.resetForm();
              }
            });
          }else {
            if (hasDuplicateEnrollments === true) {
              showDuplicateEnrollmentsPopUp()
            }else {
              updateFormValues(res);
            }
          }
        } catch (error) {
        } finally {
          setIsSearching(false);
        }
      }
    };

    if (debouncedEmail.length > 0){
      if(timeout){
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        fetchData();
      }, 3000);
    }
  }, [debouncedEmail]);

  const handleOnBlur = e => {
    formik.handleBlur(e);
  };

  const showDuplicateEnrollmentsPopUp = () => {
    MySwal.fire({
      title: t("common.attention"),
      text: t("substitution_request_page.errors.already_playing"),
      confirmButtonText: t("registration_page.fix_email"),
      allowOutsideClick: false
    }).then((res) => {
      formik.resetForm();
    });
  }

  return (
     <div>
       <Header headerBarTitle={t("substitution_request_page.header")} showHeaderExtras>
       </Header>

       <Container>
         <Row>
           <Col xs={12} className={"mt-2 mb-2"}>
             <p>{t("substitution_request_page.partner_data_note")}</p>
           </Col>
         </Row>
         <form onSubmit={formik.handleSubmit}>
           <Row>
             <Col xs={12} md={6}>
               <div className="form-group">
                 <Input
                    name="email"
                    text={t("common.form.labels.email")}
                    inputType="email"
                    inputTextValue={formik.values.email}
                    handleOnBlur={handleOnBlur}
                    handleChange={formik.handleChange}
                    hasError={!!formik.errors.email && formik.touched.email}
                 />
                 <div className='sweet-loading'>
                   <ScaleLoader
                      css={override}
                      sizeUnit={"px"}
                      size={30}
                      color={'#AFFF55'}
                      loading={isSearching}
                   />
                 </div>

                 <ErrorMessage
                    errors={formik.errors}
                    touched={formik.touched}
                    name="email"
                 />
               </div>

               <div className="form-group">
                 <Input
                    name="name"
                    text={t("common.form.labels.name")}
                    inputType="text"
                    handleChange={formik.handleChange}
                    handleOnBlur={handleOnBlur}
                    inputTextValue={formik.values.name}
                    disabled={isFilled(formik.values.original_details.name)}
                    hasError={!!formik.errors.name && formik.touched.name}
                 />

                 <ErrorMessage
                    errors={formik.errors}
                    touched={formik.touched}
                    name="name"
                 />
               </div>

               <div className="form-group">
                 <InputSelect
                    labelClasses="label-style"
                    inputType="text"
                    text={t("common.form.labels.gender")}
                 >
                   <select
                      onChange={formik.handleChange}
                      value={formik.values.gender !== '' ? formik.values.gender : 'DEFAULT'}
                      name="gender"
                      className="input-background"
                      disabled={isFilled(formik.values.original_details.gender)}
                   >
                     <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                     <option value="Masculino">{t("common.form.options.male")}</option>
                     <option value="Feminino">{t("common.form.options.female")}</option>
                   </select>
                 </InputSelect>

                 <ErrorMessage
                    errors={formik.errors}
                    touched={formik.touched}
                    name="gender"
                 />

               </div>
               <div className="form-group">
                 <Input
                    name="birthyear"
                    text={t("common.form.labels.birth_year")}
                    inputType="text"
                    handleChange={formik.handleChange}
                    handleOnBlur={handleOnBlur}
                    inputTextValue={formik.values.birthyear}
                    disabled={isFilled(formik.values.original_details.birthyear)}
                    hasError={!!formik.errors.birthyear && formik.touched.birthyear}
                 />

                 <ErrorMessage
                    errors={formik.errors}
                    touched={formik.touched}
                    name="birthyear"
                 />
               </div>

             </Col><Col xs={12} md={6}>

             <div className="form-group">
               <Input
                  name="phone"
                  text={t("common.form.labels.phone_number")}
                  inputType="text"
                  inputTextValue={formik.values.phone}
                  handleChange={formik.handleChange}
                  handleOnBlur={handleOnBlur}
                  disabled={isFilled(formik.values.original_details.phone_number)}
                  hasError={!!formik.errors.phone && formik.touched.phone}
               />

               <ErrorMessage
                  errors={formik.errors}
                  touched={formik.touched}
                  name="phone"
               />
             </div>

             {auth.user.active_enrollment.welcomepack_needed && (
                <div className="form-group">
                  <InputSelect
                     labelClasses="label-style"
                     inputType="text"
                     text={t("common.form.labels.offer")}
                  >
                    <select
                       onChange={(e) => {formik.handleChange(e); getSizesForOffer(e.target.value)}}
                       value={formik.values.offerId || 'DEFAULT'}
                       name="offerId"
                       className="input-background"
                    >
                      <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                      {state.offers && state.offers.map((offer, index) => {
                        return <option key={index} value={offer.id}>{offer.offer_name}</option>
                      })}
                    </select>
                  </InputSelect>

                  <ErrorMessage
                     errors={formik.errors}
                     touched={formik.touched}
                     name="offerId"
                  />
                </div>
             )}

             {state.sizes.length !== 0 && auth.user.active_enrollment.welcomepack_needed && (
                <div className="form-group">
                  <InputSelect
                     labelClasses="label-style"
                     inputType="text"
                     text={t("common.form.labels.offer_size")}
                  >
                    <select
                       onChange={formik.handleChange}
                       value={formik.values.offerSizeId || 'DEFAULT'}
                       name="offerSizeId"
                       className="input-background"
                    >
                      <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                      {state.sizes.map((size, index) => {
                        return <option key={index} value={size.id}>{size.size_name}</option>
                      })}
                    </select>
                  </InputSelect>

                  <ErrorMessage
                     errors={formik.errors}
                     touched={formik.touched}
                     name="offerSizeId"
                  />
                </div>
             )}

             <div className="form-group">
               <InputRadio
                  handleChange={formik.handleChange}
                  name="hasFppLicence"
                  text={t("common.form.labels.is_federated")}
                  firstRadioText={t("common.yes")}
                  secondRadioText={t("common.no")}
                  checked={formik.values.hasFppLicence}
               />

               {formik.values.hasFppLicence && (
                  <>
                    <Input
                       name="fppLicence"
                       text={t("common.form.labels.federative_license")}
                       inputType="number"
                       inputTextValue={formik.values.fppLicence}
                       handleOnBlur={handleOnBlur}
                       handleChange={formik.handleChange}
                       hasError={!!formik.errors.fppLicence && formik.touched.fppLicence}
                    />

                    <ErrorMessage
                       errors={formik.errors}
                       touched={formik.touched}
                       name="fppLicence"
                    />
                  </>
               )}
             </div>

             <div className="form-group">
               <InputRadio
                  handleChange={formik.handleChange}
                  name="hasSocialMedia"
                  isColumn
                  text={t("common.form.labels.wants_identification")}
                  firstRadioText={t("common.yes")}
                  secondRadioText={t("common.no")}
                  checked={formik.values.hasSocialMedia}
                  disabled={isFilled(formik.values.original_details.social_media)}
               />

               {formik.values.hasSocialMedia && (
                  <>
                    <Input
                       name="facebook"
                       text="facebook.com/"
                       inputType="text"
                       layout="row"
                       handleChange={formik.handleChange}
                       handleOnBlur={handleOnBlur}
                       inputTextValue={formik.values.facebook}
                       disabled={isFilled(formik.values.original_details.site_url)}
                       hasError={!!formik.errors.facebook && formik.touched.facebook}
                    />

                    <ErrorMessage
                       errors={formik.errors}
                       touched={formik.touched}
                       name="facebook"
                    />
                  </>
               )}
             </div>
             <div className="form-group">
               <CheckBox
                  handleChange={formik.handleChange}
                  id="authToShareSubInfo"
                  checked={formik.values.authToShareSubInfo}
                  name="authToShareSubInfo"
                  text={t("substitution_request_page.has_sub_permission")}
               />

               <ErrorMessage
                  errors={formik.errors}
                  touched={formik.touched}
                  name="authToShareSubInfo"
               />
             </div>

             <div className="form-group">
               <CheckBox
                  handleChange={formik.handleChange}
                  id="fppLicenceIsValid"
                  checked={formik.values.fppLicenceIsValid}
                  name="fppLicenceIsValid"
                  text={t("substitution_request_page.true_info")}
               />

               <ErrorMessage
                  errors={formik.errors}
                  touched={formik.touched}
                  name="fppLicenceIsValid"
               />
             </div>
           </Col>
           </Row>
           <Row>
             <Col xs={12} sm={{span: 5, offset: 7 }} md={{span: 3, offset: 9 }}>
               <Button type={"submit"} className={"mt-4 mb-4 w-100"} variant="primary">{t("substitution_request_page.conclude")}</Button>
             </Col>
           </Row>
         </form>
       </Container>
     </div>
  );
};

PartnerForm.propTypes = {
  onSubmit: func.isRequired
};

export default PartnerForm;
